import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { APIService } from '../fleet-management/backend-service/backend-service';
import { GlobalVariablesService } from '../global.service';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  constructor(
    private apiService: APIService,
    private globalVariable: GlobalVariablesService
  ) {}

  getSettings(): Observable<any> {
    const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
    if (!loginData.token) return of(null);

    return this.apiService.get('/api/predefined-data/groups', loginData.token).pipe(
      tap((response: any) => {
        if (response.status === 200 && Array.isArray(response.body)) {
          const datas = response.body;
          const getSettingData = (key: string) =>
            datas.find((item: any) => item.name === key)?.data || [];

          this.globalVariable.SETTING_USER_ROLES = getSettingData('USER_ROLES');
          this.globalVariable.SETTING_CREDIT_TERMS = getSettingData('CREDIT_TERMS');
          this.globalVariable.SETTING_BUSINESS_TYPES = getSettingData('BUSINESS_TYPES');
          this.globalVariable.SETTING_FINANCIAL_RATINGS = getSettingData('FINANCIAL_RATINGS');
          this.globalVariable.SETTING_TRUCK_TYPES = getSettingData('TRUCK_TYPES');
          this.globalVariable.SETTING_TRUCK_MODEL_NUMBERS = getSettingData('TRUCK_MODEL_NUMBERS');
          this.globalVariable.SETTING_TRUCK_LOADING_CAPACITY = getSettingData('TRUCK_LOADING_CAPACITY');
          this.globalVariable.SETTING_BOX_SIZE = getSettingData('BOX_SIZE');
          this.globalVariable.SETTING_BOX_LOADING_TYPES = getSettingData('BOX_LOADING_TYPES');
          this.globalVariable.SETTING_VEHICLE_MAINTENANCE = getSettingData('VEHICLE_MAINTENANCE');
          this.globalVariable.SETTING_INCIDENT_REPORT = getSettingData('INCIDENT_REPORT');
          this.globalVariable.SETTING_ROUTE_EXPERTISE = getSettingData('ROUTE_EXPERTISE');
          this.globalVariable.SETTING_INSURANCE_TYPES = getSettingData('INSURANCE_TYPES');
          this.globalVariable.SETTING_SECURITY_DEPOSIT_AMOUNT = getSettingData('SECURITY_DEPOSIT_AMOUNT');
          this.globalVariable.SETTING_QUANTITY_TYPES = getSettingData('QUANTITY_TYPES');
          this.globalVariable.SETTING_HANDLING_METHODS = getSettingData('HANDLING_METHODS');
          this.globalVariable.SETTING_DIMENSION = getSettingData('DIMENSION');

          this.globalVariable.isLoggedIn = true;
        }
      }),
      catchError((error) => {
        console.error('Error loading settings:', error);
        return of(null);
      })
    );
  }
}
